import { useEffect } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";
import { logWarn } from "helpers/log-helper/log-helper";
import { LogPrefix } from "types/logging";
import { usePickSearchParams } from "hooks/usePickSearchParams";
import { useCartStore } from "store/cartStore";

/**
 * Logging used to identify diff between cart delivery type
 * and delivery type in url, when location changes from using the native forward-/backward-buttons
 * and having previously manually switched between delivery types.
 *
 * Used to get a sense of how often this occurs and if it potentially is a problem.
 * Introduced as of BEST-3116, which opened up for this diff to occur.
 */
export const useLogDeliveryTypeDiff = () => {
	const location = useLocation();
	const navType = useNavigationType();
	const { deliveryOptionType } = usePickSearchParams(["deliveryOptionType"]);
	const { cart } = useCartStore();

	useEffect(() => {
		if (navType === NavigationType.Pop) {
			if (cart && cart.deliveryInfo.type !== deliveryOptionType) {
				logWarn(
					LogPrefix.Cart,
					`Delivery type for Cart (${cart.deliveryInfo.type}) differs from delivery type in URL (${deliveryOptionType})`,
				);
			}
		}
	}, [cart, deliveryOptionType, location, navType]);
};
